module.exports = __webpack_public_path__ + "img/shrimps.e7ca84da.jpg";